import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';

// actions
import { sessionCreate } from '../../actions/sessionActions';

// components
import { Button } from '../shared/_form';
import { SimplePanel } from '../shared/_panel';

// lib
import handleFormChange from '../../lib/handleFormChange';

class New extends React.Component {
  static propTypes = {
    token: PropTypes.instanceOf(Immutable.Map)
  }

  constructor(props) {
    super(props);

    this.state = { data: Immutable.Map() };
  }

  render() {
    const tokenLoading = this.props.token.get('loading');

    return (
      <div className='body__content body__content--center'>
        <SimplePanel header='Welcome'>
          <div className='session__logo' />
          <div className='session__message'>
            <span className='session__message__line'>Welcome to</span>
            <span className='session__message__line'>Open Books MD!</span>
          </div>
          { this._renderError() }
          <div className='form'>
            <form onSubmit={ this._handleSubmit }>
              <input className='form__field form__field--rounded'
                name='email'
                onChange={ handleFormChange(this) }
                placeholder='Email address'
                type='email' />
              <input className='form__field form__field--rounded'
                name='password'
                onChange={ handleFormChange(this) }
                placeholder='Password'
                type='password' />
              <div className='session__form__password-reset'>
                <Link to='/password-resets/new'>Forgot your password?</Link>
              </div>
              <div className='form__submit session__form__submit'>
                <Link className='form__button form__button--purple mobile-only'
                  to='/reps/new/1'>
                  Sign Up
                </Link>
                <Button className='form__button form__button--green'
                  loading={ tokenLoading }>
                  Sign In
                </Button>
              </div>
            </form>
          </div>
        </SimplePanel>
      </div>
    );
  }

  // private

  _handleSubmit = this._handleSubmit.bind(this);

  _handleSubmit(e) {
    e.preventDefault();

    const form = this.state.data.get('form') || {};

    this.props.dispatch(sessionCreate(form.email, form.password));
  }

  _renderError() {
    let component;

    const token = this.props.token;
    const error = token.get('error') || {};

    if (error.status === 401) {
      component = (
        <div className='panel__form__error'>
          Invalid email address or password
        </div>
      );
    }

    return component;
  }
}

const mapStateToProps = (state) => {
  return {
    token: state.get('token')
  };
};

export default connect(mapStateToProps)(New);



// WEBPACK FOOTER //
// ./app/components/sessions/New.jsx